import React, {createContext, useContext, useMemo} from 'react';

export type SidebarContextValue = {
	toggleSidebar: () => void;
	setHeaderScroll: (scrollElement: HTMLElement) => void;
};

export type TableContextType = React.Context<SidebarContextValue>;

export const SidebarContext = createContext<SidebarContextValue>({
	toggleSidebar: () => {
		/* noop */
	},
	setHeaderScroll: () => {
		/* noop */
	},
});

export const useSidebarContext = () => {
	return useContext<SidebarContextValue>(SidebarContext);
};

type SidebarProviderProps = {
	toggleSidebar: () => void;
	setHeaderScroll: (scrollElement: HTMLElement) => void;
	children: React.ReactNode;
};

const SidebarProvider = ({
	toggleSidebar,
	setHeaderScroll,
	children,
}: SidebarProviderProps) => {
	const value = useMemo(() => {
		return {
			toggleSidebar,
			setHeaderScroll,
		};
	}, [toggleSidebar, setHeaderScroll]);
	return (
		<SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
	);
};

export default SidebarProvider;
